// M-Tech Industrial — the FRONTEND face of the client config seam. The '@client/config'
// vite alias resolves here in this fork (web/vite.config.js repoint — the
// fork's one sanctioned edit outside client-custom/).
//
// ONE SOURCE OF TRUTH: these values mirror ../config/client.config.js (the
// server face). The config suite asserts the two never drift — edit BOTH
// or the runner goes RED.

export const BRAND_NAME = 'M-Tech Industrial';
export const BRAND_TAGLINE = 'World Class Manufacturing and Engineering Systems';
export const BRAND_SUBTITLE = 'M-Tech Industrial';
export const APP_TITLE = 'M-Tech Industrial — Zebra Stride';
export const CUSTOMER_LABEL = 'Customer';

export const ADMIN_GROUP = 'site-admins';

// The site-switchers group — membership reveals the site switcher (see the
// server-side config). Mirrors client.config.js; the config suite checks.
export const SITE_SWITCH_GROUP = 'site-switchers';

// Workspaces — mirrors the server seam's workspacesEnabled (ON for this client).
export const WORKSPACES_ENABLED = true;
export const STORAGE_PREFIX = 'm-tech-industrial';

// VERIFIED against the client's Jira, 2026-09-16 — the link type is named
// "Link" here, not "Hierarchy", and the comparison is case-sensitive.
export const PROJECT_ISSUE_TYPE = 'Project';
export const MODULE_ISSUE_TYPE = 'Module';
export const LINK_TYPE_NAME = 'Link';

// null until a board exists (see the server face for why not customfield_10001).
export const WPO_FIELD = null;

export const ACCENT_RGB = { r: 135, g: 21, b: 29 };  // #87151D

export const CUSTOMS_ALLOWED_HOSTS = [];

// This fork's own view of a field on the work item screen (the product's
// FIELD_VIEWS seam — modules/database/work-items/frontend/components/FieldView),
// in a screen tab of its own (client-custom/scripts/setup/zebra-fields-setup.mjs):
//   "Zebra Project Creation"  on a Business Development: Project Creation filled in
//     from it, then the work item moved into the new project under its Project
//     work item (customs/project-creation/BdProjectField.jsx)
// ("Zebra Procurement" and "Document Approvals" are the product's Document field
// type — drawn by the product, their settings saved on the fields by the same
// setup script.) Loaded through the '@client/customs' alias, never a relative
// path (Vite bundles this file).
export const FIELD_VIEWS = [
  { field: 'Zebra Project Creation', load: () => import('@client/customs/project-creation/BdProjectField.jsx') },
];
